import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import store from '@/store'

export default function useAdminsList() {
  const toast = useToast()

  const refAdminsListTable = ref(null)
  const loadingAdmins = ref(false)
  const editAdminData = ref(null)

  const tableColumns = [
    { key: 'email' },
    { key: 'role' },
    { key: 'actions' },
  ]

  const fetchAdmins = (ctx, callback) => {
    loadingAdmins.value = true
    store
      .dispatch('admins/fetchAdmins')
      .then(result => {
        loadingAdmins.value = false
        callback(result)
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching Admins list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchData = () => {
    refAdminsListTable.value.refresh()
  }

  return {
    loadingAdmins,
    refAdminsListTable,
    editAdminData,
    tableColumns,

    fetchAdmins,
    refetchData,
  }
}
